import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import { getRegistrationReport } from './services';
import Papa from 'papaparse';

const tableStyle = {
  minWidth: 650, // Adjust the width as needed
};

const ProfileReport = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getRegistrationReport().then((res) => {
      console.log(res.data);
      setData(res.data);
    });
  }, []);

  const handleExportCSV = () => {
    try {
      // Convert the data to CSV format
      const csvData = Papa.unparse(data);

      // Create a Blob with the CSV data
      const blob = new Blob([csvData], { type: 'text/csv' });

      // Create a URL for the Blob
      const blobURL = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = blobURL;
      a.download = 'profile_report.csv';

      // Trigger the click event on the anchor element
      document.body.appendChild(a);
      a.click();

      // Cleanup
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error('Error exporting data to CSV:', error);
    }
  };

  return (
    <div style={{
      marginTop: '16px',
    }}>
      <Button style={{marginBottom:'10px'}} variant="contained" color="primary" onClick={handleExportCSV}>
        Export to CSV
      </Button>
      <TableContainer component={Paper}>
        <Table style={tableStyle}>
          <TableHead>
            <TableRow>
              <TableCell>Employee ID</TableCell>
              <TableCell>Employee Name</TableCell>
              <TableCell>Created First Profiles</TableCell>
              <TableCell>Updated Profiles</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.EmployeeID}>
                <TableCell>{row.EmployeeID}</TableCell>
                <TableCell>{row.EmployeeName}</TableCell>
                <TableCell>{row.CreatedFirstProfiles}</TableCell>
                <TableCell>{row.UpdatedProfiles}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ProfileReport;
